// extracted by mini-css-extract-plugin
export var displayNone = "_u8-6";
export var imgContainer = "_u8-2";
export var overflowHidden = "_u8-3";
export var productInfoCardButtonContainer = "_u8-5";
export var productTitleText = "_u8-4";
export var rightArrow = "_u8-1";
export var rightArrowContainer = "_u8-0";